<template></template>

<script lang="ts" setup>
import { useCommonDataStore } from '@/modules/broadcast-portal-post-login/store';
import { ApprovalStatus, BusinessType, Country, DurationOfWorkMeasurement, Gender, IdentityType, Nationality } from '@/modules/broadcast-portal-post-login/types';

interface Props {
    countries?: Array<Country>;
    genders?: Array<Gender>;
    identityTypes?: Array<IdentityType>;
    nationalities?: Array<Nationality>;
    businessTypes?: Array<BusinessType>;
    durationOfWorkMeasurements?: Array<DurationOfWorkMeasurement>;
    approvalStatuses?: Array<ApprovalStatus>;
}

const props = defineProps<Props>();

useCommonDataStore().$patch(props)
</script>
